import React, { FC } from 'react';

import { Box, SxProps, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { convertToDecimals, currency, perHour } from '@pharmaplan/common';
import { ChipType, SkeletonVariants } from '../../../helpers/Constants';

import WithSkeleton from '../WithSkeleton';
import CustomChip from '../CustomChip';
import styles from './styles';

interface IHourlyRateChipLabel {
  type: ChipType;
  rate?: number | string;
  successAction: string;
  label?: string;
  strikeRate?: number | string | null;
  customContainerStyle?: SxProps;
  customLabelStyle?: SxProps;
  customChip?: React.ReactNode;
  infoText?: string;
}

const HourlyRateChipLabel: FC<IHourlyRateChipLabel> = ({
  type,
  rate,
  label,
  successAction,
  strikeRate,
  customLabelStyle,
  customContainerStyle,
  customChip,
  infoText,
}) => {
  const SkeletonBox = WithSkeleton({
    successAction,
    variant: SkeletonVariants.rounded,
  })(Box);

  return (
    <Box sx={[styles.itemContainer, customContainerStyle] as SxProps}>
      {!!label && (
        <SkeletonBox sx={[styles.title, customLabelStyle] as SxProps}>
            {label}
            {!!infoText && (
            <Tooltip placement="top" title={infoText}>
              <InfoOutlinedIcon sx={{ ml: '3px', fontSize: 13, verticalAlign: 'middle' }} />
            </Tooltip>
            )}
        </SkeletonBox>
      )}

      <SkeletonBox sx={styles.chip}>
        {strikeRate && (
          <Typography sx={styles.strikeRate}>
            {`${currency}${convertToDecimals(
              parseFloat((strikeRate as string) ?? '0'),
            )}${perHour}`}
          </Typography>
        )}
        {customChip ?? (
          <CustomChip
            type={type}
            label={`${currency}${convertToDecimals(
              parseFloat((rate as string) ?? '0'),
            )}${perHour}`}
          />
        )}
      </SkeletonBox>
    </Box>
  );
};

export default HourlyRateChipLabel;
